/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ComponentClassNames } from "@microsoft/shifts-ui-core";

import { BaseShiftStyles } from "./BaseShiftCard.styles";

/**
 * Gets the icon style for the component. Handles the different icon types.
 * @param styles The styles for the component.
 * @param icon The icon to display.
 * @returns The icon styling.
 */
export const getIconStyle = (styles: ComponentClassNames<BaseShiftStyles>, icon: string): string|undefined => {
    if (!icon) {
        return undefined;
    }

    switch (icon) {
        case "teams-location-add":
            return styles.teamsLocationAddIcon;
        default:
            return styles.icon;
    }
};